import apiFailureImageUrl from "@/assets/api-failure.svg"
import HeroImage from "@/components/HeroImage"
import Page from "@/components/Page"
import { Button } from "@/components/chadcn/Button"
import { ROUTES } from "@/routes"
import { useLocation, useNavigate } from "react-router"

type LocationState = {
  error?: string
} | null

const DeviceLinkingErrorPage = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const state = location.state as LocationState

  return (
    <Page showAppbar={false}>
      <HeroImage src={apiFailureImageUrl} />
      <div className="flex flex-col gap-6">
        <h1 className="text-center text-h2">Device linking failed</h1>
        <p className="text-center text-base text-primary-contrast/70">
          We were unable to link your device.
          {state?.error ? ` (${state.error})` : ""} Please try again or contact support if the
          problem persists.
        </p>
        <div className="flex flex-col gap-3">
          <Button type="button" className="w-full py-2 text-base" onClick={() => navigate(-1)}>
            Try again
          </Button>
          <Button
            type="button"
            variant="outline"
            className="w-full py-2 text-base"
            onClick={() => navigate(ROUTES.DASHBOARD, { replace: true })}
          >
            Go to dashboard
          </Button>
        </div>
      </div>
    </Page>
  )
}

export default DeviceLinkingErrorPage
